<template>
	<v-menu offset-y eager>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
				<v-icon>mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list dense>
			<v-list-item v-if="item.item && item.item._id" link @click="$emit('open-item', item)">
				<v-list-item-title class="size9">Apri prodotto</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.item && item.item.url" link :href="item.item.url" target="_blank">
				<v-list-item-title class="size9">Vedi sul sito</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.order && item.order._id" link @click="$emit('open-order', item)">
				<v-list-item-title class="size9">Apri ordine {{ item.order.number || '' }}</v-list-item-title>
			</v-list-item>
			<template v-if="item.status === 'waiting'">
				<v-divider></v-divider>
				<v-list-item link @click="$emit('cancel', item)">
					<v-list-item-title class="size9">Annulla richiesta</v-list-item-title>
				</v-list-item>
			</template>
		</v-list>
	</v-menu>
</template>

<script>
// menu a tre puntini di una richiesta di avviso: le azioni dipendono dallo stato.
// Prodotto e ordine li apre la pagina, che si fa riportare indietro (openWithReturn)
export default {
	name: 'AlertRowMenu',
	props: {
		item: { type: Object, required: true },
	},
};
</script>
